/**
 * UserMenu — shows current user in top bar, with logout action.
 */

import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { logoutRequested } from '../ducks';
import { selectCurrentUser } from '../selectors';

export function UserMenu() {
  const dispatch = useDispatch();
  const user = useSelector(selectCurrentUser);
  const [isOpen, setIsOpen] = useState(false);

  if (!user) return null;

  const handleLogout = () => {
    dispatch(logoutRequested());
    setIsOpen(false);
  };

  return (
    <div className="user-menu" data-testid="user-menu">
      <button
        className="user-menu-trigger"
        onClick={() => setIsOpen(!isOpen)}
        data-testid="user-menu-trigger"
      >
        <span className="user-avatar">{user.display_name.charAt(0).toUpperCase()}</span>
        <span className="user-name">{user.display_name}</span>
      </button>

      {isOpen && (
        <div className="user-menu-dropdown" data-testid="user-menu-dropdown">
          <div className="user-info">
            <span className="user-email">{user.email}</span>
            {user.role && (
              <span className={`user-role-badge${user.role === 'admin' ? ' user-role-badge--admin' : ''}`}>
                {user.role}
              </span>
            )}
          </div>
          <button
            className="logout-button"
            onClick={handleLogout}
            data-testid="logout-button"
          >
            Sign Out
          </button>
        </div>
      )}
    </div>
  );
}

export default UserMenu;
